import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import SettingForm from './SettingFormik'
import { IServiceProgramObject } from '../../types/service-program'

interface IServiceProgramEditModal {
  serviceProgram: IServiceProgramObject
  routeProps: RouteComponentProps<any>
  onUpdate: (serviceProgram: IServiceProgramObject) => Promise<void>
}

export default class ServiceProgramEditModal extends React.Component<IServiceProgramEditModal> {
  public render() {
    const { serviceProgram } = this.props
    return (
      <Modal>
        {this.props.serviceProgram && (
          <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
            <div className='bg-white col-4 relative'>
              <SettingForm
                title={'EDIT SERVICE PROGRAM'}
                labelTitle='Service Program'
                setting={{ id: serviceProgram.id, label: serviceProgram.name }}
                onSubmit={this.handleSubmit}
                onSuccess={this.handleSubmitSuccess}
              >
                <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                  Cancel
                </button>
                <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                  Edit
                </button>
              </SettingForm>
            </div>
          </div>
        )}
      </Modal>
    )
  }

  private onCancel = () => {
    this.props.routeProps.history.push('/global-settings/service-program')
  }

  private handleSubmit = (name: string) => {
    return this.props.onUpdate({ ...this.props.serviceProgram, name })
  }

  private handleSubmitSuccess = () => {
    setTimeout(() => {
      this.props.routeProps.history.push('/global-settings/service-program')
    }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ServiceProgramEditModal.tsx